import { cap } from '../../State'
import { translations } from '../../translations'

export const getPercentage = (totalConversations, count) =>
  totalConversations > 0
    ? parseFloat((Math.ceil((count.length / totalConversations) * 10000) / 100).toFixed(2)) || 0
    : 0

export const labelBarChart = (item) => {
  const t = translations[cap.language.state || 'IT'] || translations.IT
  switch (item) {
    case 'trasfertaConversations':
      return t.stChartTrasferteCreate
    case 'errorHandled':
      return t.stChartInoltrateOperatore
    case 'realError':
      return t.errori
    case 'noraIsExcluded':
      return t.stChartNoraEsclusa
    case 'openPauseConversation':
      return t.inAttesaDiConferma
    case 'ignoredConversation':
      return t.stChartConversazioniIgnorate
    case 'handledByOperator':
      return t.stChartInCaricoOperatore
    case 'handlerCorrectNora':
      return t.stChartCorrettamenteGestite
    default:
      return item
  }
}
